import { Component } from '@theme/component';

/**
 * Lets a shopper pick 1/2/3 tubes before adding to cart. Drives the existing
 * native quantity-selector-component rather than reimplementing quantity
 * logic, so add-to-cart, accelerated checkout, and the sticky bar all stay
 * in sync with the selected pack size.
 */
class PackSelectorComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Sync the native quantity input to whichever pack is marked selected by
    // default (e.g. the 2-tube "most popular" option), since it otherwise
    // loads at 1. Deferred a tick so the quantity-selector-component (loaded
    // separately) has finished upgrading first.
    requestAnimationFrame(() => {
      const selected = this.querySelector('[data-qty].is-selected');
      if (selected instanceof HTMLElement) {
        this.#applyQuantity(selected);
      }
    });
  }

  /**
   * @param {Event} event
   */
  selectPack(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const button = target.closest('[data-qty]');
    if (!(button instanceof HTMLElement)) return;

    this.#applyQuantity(button);
  }

  /**
   * @param {HTMLElement} button
   */
  #applyQuantity(button) {
    const qty = parseInt(button.dataset.qty || '', 10);
    if (!qty) return;

    this.querySelectorAll('[data-qty]').forEach((option) => {
      const isSelected = option === button;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    const section = this.closest('.shopify-section') || document;
    const quantitySelector = section.querySelector('quantity-selector-component');
    if (!quantitySelector) return;

    if (typeof quantitySelector.setValue === 'function') {
      quantitySelector.setValue(String(qty));
    }
    if (typeof quantitySelector.onQuantityChange === 'function') {
      quantitySelector.onQuantityChange();
    }
    if (typeof quantitySelector.updateButtonStates === 'function') {
      quantitySelector.updateButtonStates();
    }
  }
}

if (!customElements.get('pack-selector-component')) {
  customElements.define('pack-selector-component', PackSelectorComponent);
}
